<template>
  <el-dialog
    :visible.sync="visable"
    title="选择短信模版"
    width="30%"
    :before-close="closeDialog"
  >
    <div>
      <el-button @click="submit">确定</el-button>
      <el-button @click="closeDialog">取消</el-button>
    </div>
    <span>当前选中模版:{{ choiceName }}</span>
    <el-tree :data="tree" :props="defaultProps" @node-click="handleNodeClick" />
  </el-dialog>
</template>

<script>
import _ from "lodash";
export default {
  name: "SmsTemplateTree",
  data() {
    return {
      tree: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      choiceName: "",
      choice: "",
    };
  },
  props: {
    visable: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getTree();
  },
  methods: {
    getTree() {
      this.$myhttp
        .post(
          "admin/SmsTemplate/getTemplateTree",
          {},
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          // 异步执行成功后
          this.tree = res.data.data;
        });
    },
    closeDialog() {
      this.$emit("close", false);
    },
    handleNodeClick(data) {
      if (_.hasIn(data, "content")) {
        this.choiceName = _.get(data, "name", "");
        this.choice = data;
      }
    },
    submit() {
      this.$emit("node-click", this.choice);
      this.closeDialog();
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Admin/Butler/SmsTemplateTree.vue